module.exports = __webpack_public_path__ + "static/media/SWT_04.d0aebbde.jpeg";